import React from "react";
import CountUp from "react-countup";

import img from "../../media/images/landing-page-image-2.png";
import icon from "../../media/images/Full-Body-Wax-Price.png";
import IMGFemale from "../../media/images/gallery/pocket-friendly-offers.jpg"


import MainWhy from "../femaleServices/bodyPolish01.jpg"

import img1 from "../../media/images/Mens-Waxing.png";
import img2 from "../../media/images/Mens-Waxing-Delhi.png";
import img3 from "../../media/images/Male-Full-Body-Waxing-Cost-In-Delhi.png";
import img4 from "../../media/images/Full-Body-Waxing.png";
import img5 from "../../media/images/Men-Body-Waxing-Near-Me.png";
import img6 from "../../media/images/landing-page-image-1.png";

const WhyUsFemale = () => {

  return (
    <div >
      <div className="why-us">
        <div>
          <h2 className="why-us-heading why-us-female-heading">Pick Your Favorite Salon & Parlour at Home Service</h2>
          <div className="why-us-icon">
            {/* <img title="Body Waxing Near Me" src={icon} alt="img" /> */}
          </div>
          <div className="why-us-text female-why-us-desc">
         Best Quality Products | Trained & Verified Beauticians | Pocket-Friendly Offers | Delhi NCR, Noida, Faridabad, Greater Noida
          </div>

          <div className="why-us-content">
            <div className="why-us-content-col">
              <div className="why-us-content-col-list">
                <div className="why-us-content-col-list-icon">
                  <img title="Hair stylist at home" src={img1} alt="img" />
                </div>
                <div className="why-us-content-col-list-content">
                  <div className="why-us-content-col-list-content-heading">
                   Head & Body Massage
                  </div>
                  <div className="why-us-content-col-list-content-text">
         Pamper your inner and outer body at home with our soothing and relaxing body massage services because In & out beauty matters! Get personalized salon services brought to your doorstep with our Salon at Home.
                  </div>
                </div>
              </div>

              <div className="why-us-content-col-list">
                <div className="why-us-content-col-list-icon">
                  <img title="Beauty parlour services at doorstep" src={img2} alt="img" />
                </div>
                <div className="why-us-content-col-list-content">
                  <div className="why-us-content-col-list-content-heading">
                  Facial & Cleanup
                  </div>
                  <div className="why-us-content-col-list-content-text">
               Let your beautiful face talk. Enjoy the best offers on facial massage 
               in your own comfort space to revamp the quality of your facial skin with our Salon at Home services.
                  </div>
                </div>
              </div>

              <div className="why-us-content-col-list">
                <div className="why-us-content-col-list-icon">
                  <img title="Super salon at home" src={img3} alt="img" />
                </div>
                <div className="why-us-content-col-list-content">
                  <div className="why-us-content-col-list-content-heading">
                Waxing at home
                  </div>
                  <div className="why-us-content-col-list-content-text">
                 Don't have time to go to the salon? Don’t worry! Get rid of unwanted hair at home with our personalized
                  salon services brought to your comfort and privacy. Save your precious time with our Salon at Home services.
                  </div>
                </div>
              </div>
            </div>

            <div className="why-us-content-col female-why-us-service-main-img">
              <img title="Body polish near me" src={MainWhy} alt="img" />
            </div>

            <div className="why-us-content-col">
              <div className="why-us-content-col-list">
                <div className="why-us-content-col-list-icon">
                  <img title="Body polish at home" src={img4} alt="img" />
                </div>
                <div className="why-us-content-col-list-content">
                  <div className="why-us-content-col-list-content-heading">
                  
                    Hair Spa at home
                  </div>
                  <div className="why-us-content-col-list-content-text">
              From oil massaging to hair coloring, we have all the amazing salon services to make your hair more
               beautiful with hassle-free Hair Spa solutions delivered to your home. Get salon-perfect hair without leaving your home
                  </div>
                </div>
              </div>

              <div className="why-us-content-col-list">
                <div className="why-us-content-col-list-icon">
                  <img title="Body polish expert at home" src={img5} alt="img" />
                </div>
                <div className="why-us-content-col-list-content">
                  <div className="why-us-content-col-list-content-heading">
                  Manicure & Pedicure
                  </div>
                  <div className="why-us-content-col-list-content-text">
                   Get the perfect curation and care for your nails, hands, and feet delivered to your home with the best
                    and most glamorizing mani-pedi offers in our Salon at Home services.
                  </div>
                </div>
              </div>

              <div className="why-us-content-col-list">
                <div className="why-us-content-col-list-icon">
                  <img title="Hair color at home" src={img6} alt="img" />
                </div>
                <div className="why-us-content-col-list-content">
                  <div className="why-us-content-col-list-content-heading">
                  Bleach & D-tan
                  </div>
                  <div className="why-us-content-col-list-content-text">
                   Avoid wax and threading pain by opting for the effective and amazing bleach & D-tan treatment with our Salon at Home services.
                    Enjoy the convenience of salon services in the comfort of your home.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="why-us-increment">
        <div>
          <div className="why-us-increment-col">
            <div className="why-us-increment-col-heading">
              <CountUp end={85} duration="5" enableScrollSpy /> %
            </div>
            <div className="why-us-increment-col-text">
              OF PEOPLE THINK BAD GROOMING IS A MAJOR TURN OFF IN MENS
              PERSONALITY.
            </div>
          </div>

          <div className="why-us-increment-col">
            <div className="why-us-increment-col-heading">
              <CountUp end={80} duration="5" enableScrollSpy /> %
            </div>
            <div className="why-us-increment-col-text">
              OF PEOPLE THINK, MEN SHOULD MANSCAPE UNDERARMS AND BELOW THE BELT
            </div>
          </div>

          <div className="why-us-increment-col">
            <div className="why-us-increment-col-heading">
              <CountUp end={89} duration="5" enableScrollSpy /> %
            </div>
            <div className="why-us-increment-col-text">
              OF MEN THINK GROOMING IS ESSENTIAL TO THEIR PROFESSIONAL SUCCESS
            </div>
          </div>

        
          
        </div>
          
          <span id="testimonial">

          
          <a href="#services" className="landing-page-button-web-yellow">
                  Book Service Now
                  </a>

                  
                  <a href="#services" className="landing-page-button-mobile-yellow">
                  Book Service Now
                  </a>
          </span>
                  
      </div>
    </div>
  );
};

export default WhyUsFemale;

// export default WhyUsFemale